import { render } from "./FamousCompDesk.vue?vue&type=template&id=8f7f19bc&scoped=true"
import script from "./FamousCompDesk.vue?vue&type=script&lang=js"
export * from "./FamousCompDesk.vue?vue&type=script&lang=js"

import "./FamousCompDesk.vue?vue&type=style&index=0&id=8f7f19bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f7f19bc"]])

export default __exports__